"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function AddCircleThin(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,1 C4.13400675,1 1,4.13400675 1,8 C1,11.8659932 4.13400675,15 8,15 C11.8659932,15 15,11.8659932 15,8 C15,4.13400675 11.8659932,1 8,1 Z M8.5,4 L8.5,7.499 L12,7.5 L12,8.5 L8.5,8.5 L8.5,12 L7.5,12 L7.5,8.5 L4,8.5 L4,7.5 L7.5,7.5 L7.5,4 L8.5,4 Z" })));
}
exports.default = AddCircleThin;
//# sourceMappingURL=AddCircleThin.js.map